module.exports = __webpack_public_path__ + "static/media/display22.4c781c92.jpg";